import axios from 'axios';

let prefix = "/postcode"

const PostcodeApi = {
	
	getAllPostcodeList(payload){
		return axios.get( prefix + "/list-allk", {params: payload})
	},
	getAvailablePostcodeList(payload){
		return axios.get( prefix + "/list-available", {params: payload})
	},

}

export default PostcodeApi;